import React from "react";
import "./loading-overlay.scss";

const LoadingOverlay = () => {
    return <div className="loading">Loading ... </div>;
};

export default LoadingOverlay;
